export default "__VITE_ASSET__CDPtzDnZ__"